const validate = require("validate-edrpou");
import i18n from "~/plugins/i18n";

const edrpouValidator = (value) => {
  return validate(value) || i18n.global.t("validate.edrpou_failde");
};

export { edrpouValidator };
